<template>
  <v-text-field
    v-model="search"
    :append-icon="search ? 'close' : 'search'"
    @click:append="this.resetInput"
    label="Search"
    single-line
    hide-details
    @input="this.debounceInput"
  ></v-text-field>
</template>

<script>
  import debounce from 'debounce';

  export default {
  props: {
    value: {
      required: true,
    },
  },
  data: () => {
    return {
      search: '',
    };
  },
  created() {
    this.search = this.value;
  },
  methods: {
    debounceInput: debounce(function(e) {
      this.$emit('input', e);
    }, 300),
    resetInput() {
      this.search = '';
      this.$emit('input', '');
    },
  },
};
</script>


